import { render } from "./ProfileBurger.vue?vue&type=template&id=74915e56&lang=pug"
import script from "./ProfileBurger.vue?vue&type=script&lang=js"
export * from "./ProfileBurger.vue?vue&type=script&lang=js"

import "./ProfileBurger.vue?vue&type=style&index=0&id=74915e56&lang=scss&SCOPED=true"

import exportComponent from "/Users/aladdin/Documents/Petar/fairwey-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__